<template>
  <van-popup
    v-model="show"
    round
    style="height: 80%; box-sizing: border-box"
    closeable
    class="intro-pop"
    position="bottom"
  >
    <div class="content">
      <div class="content-item">
        <div class="title">
          {{ $t("rule_fzywk_title1") }}
        </div>
        <div class="content-item-intro">
          {{ $t("rule_fzywk_cont1") }}
        </div>
        <div class="content-item-note">
          {{ $t("rule_fzywk_note") }}
        </div>
        <div class="content-item-note">
          {{ $t("rule_fzywk_note1") }}
        </div>
      </div>
      <div class="content-item">
        <div class="title">
          {{ $t("rule_fzywk_title2") }}
        </div>
        <div class="content-item-con">
          <div class="con-title">
            {{ $t("rule_fzywk_til2") }}
          </div>
          <div class="con">
            {{ $t("rule_fzywk_cont2") }}
          </div>
        </div>
      </div>
      <div class="content-item">
        <div class="title">
          {{ $t("rule_fzywk_title3") }}
        </div>
        <div class="content-item-con">
          <div class="con-title">
            {{ $t("rule_fzywk_til3") }}
          </div>
          <div class="con">
            {{ $t("rule_fzywk_cont3") }}
          </div>
        </div>
        <div class="content-item-con">
          <div class="con-title">
            {{ $t("rule_fzywk_til3_1") }}
          </div>
          <div class="con-table">
            <table data-v-e203cbb4="" class="table">
              <thead data-v-e203cbb4="" class="head">
                <tr data-v-e203cbb4="">
                  <th data-v-e203cbb4="">{{ $t("rule_fzywk_tab1") }}</th>
                  <th data-v-e203cbb4="">{{ $t("rule_fzywk_tab2") }}</th>
                  <th data-v-e203cbb4="">{{ $t("rule_fzywk_tab3") }}</th>
                  <th data-v-e203cbb4="">{{ $t("rule_fzywk_tab4") }}</th>
                </tr>
              </thead>
              <tbody data-v-e203cbb4="">
                <tr
                  v-for="(item, index) in notStakingRateList"
                  :key="item.id"
                  data-v-e203cbb4=""
                  class="row"
                >
                  <td
                    v-if="index != notStakingRateList.length - 1"
                    data-v-557a7b05=""
                  >
                    {{ index + 1 }}
                  </td>
                  <td
                    v-if="index != notStakingRateList.length - 1"
                    data-v-557a7b05=""
                  >
                    {{ item.money }} ~ {{ notStakingRateList[index + 1].money }}
                  </td>
                  <td
                    v-if="index != notStakingRateList.length - 1"
                    data-v-557a7b05=""
                  >
                    {{ item.rate }} ~ {{ notStakingRateList[index + 1].rate }}
                  </td>
                  <td
                    v-if="index == 0 && index != notStakingRateList.length - 1"
                    data-v-557a7b05=""
                    rowspan="8"
                  >
                    ETH
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    notStakingRateList: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding-top: 60px;
  padding: 60px 15px 5px;
  .content-item {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    &-intro {
      color: #7d919d;
      font-size: 14px;
      margin-top: 25px;
    }
    &-note {
      background: #f7f7f7;
      border-radius: 10px;
      padding: 15px 10px;
      font-size: 14px;
      line-height: 1.5;
      margin-top: 10px;
    }
    &-con {
      .con-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-top: 25px;
        &:before {
          content: "";
          display: block;
          width: 7px;
          height: 7px;
          margin-right: 5px;
          background: #000;
        }
      }
      .con {
        font-size: 14px;
        margin-top: 10px;
        color: #7d919d;
      }
      .con-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
        font-size: 14px;
        color: #7d919d;
        .table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
          font-size: 14px;
          color: #7d919d;
          margin: auto;
          th {
            border: 1px solid #c9c9c9;
            text-align: center;
          }
          .row {
            td {
              font-size: 10px;
              text-align: center;
              padding: 3px 0;
              border: 1px solid #c9c9c9;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 640px) {
  .intro-pop {
    width: 540px !important;
    left: unset;
  }
  .content {
    padding-top: 60px;
    padding: 60px 15px 5px;
    .content-item {
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;
      margin-bottom: 20px;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      &-intro {
        color: #7d919d;
        font-size: 14px;
        margin-top: 25px;
      }
      &-note {
        background: #f7f7f7;
        border-radius: 10px;
        padding: 15px 10px;
        font-size: 14px;
        line-height: 1.5;
        margin-top: 10px;
      }
      &-con {
        .con-title {
          display: flex;
          align-items: center;
          font-size: 14px;
          margin-top: 25px;
          &:before {
            content: "";
            display: block;
            width: 7px;
            height: 7px;
            margin-right: 5px;
            background: #000;
          }
        }
        .con {
          font-size: 14px;
          margin-top: 10px;
          color: #7d919d;
        }
        .con-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
          font-size: 14px;
          color: #7d919d;
          .table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            font-size: 14px;
            color: #7d919d;
            margin: auto;
            th {
              border: 1px solid #c9c9c9;
              text-align: center;
            }
            .row {
              td {
                font-size: 10px;
                text-align: center;
                padding: 3px 0;
                border: 1px solid #c9c9c9;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
</style>